import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-contact-form-modal',
    templateUrl: './contact-form.component.html',
    styleUrls: ['./contact-form.component.scss'],
    standalone: false
})


export class ContactFormModalComponent {
  formData = {
    email: '',
    subject: '',
    message: '',
    attachments: [] as File[],
  };
  submitted = false;
  constructor(public activeModal: NgbActiveModal,
  ) {}

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const filesArray = Array.from(input.files).slice(0, 5);
    this.formData.attachments = filesArray;
  }

  submit(): void {
    this.submitted = true;
    if (!this.formData.email || !this.formData.subject || !this.formData.message) {
      return;
    }
  
    console.log('Submitting form with data:', this.formData);
    this.activeModal.close(this.formData); 
    
  }
}
